<template>
  <v-sheet class="cardDashboard" color="transparent">
    <v-row class="ma-0">
      <div
        :style="`${
          mdAndDown ? 'width: 100%' : `width: calc(100% - ${width}px);`
        }`"
      >
        <v-slider
          v-if="showTimeLineClustering"
          v-model="valueSliderMap"
          :max="12"
          :min="1"
          :step="1"
          thumb-label="always"
          class="mt-6"
          append-icon="mdi-plus"
          prepend-icon="mdi-minus"
          @click:append="addHours"
          @click:prepend="deleteHours"
        >
          <template v-slot:thumb-label="{ modelValue }">
            <v-sheet color="transparent" width="150">
              {{ season(modelValue) }}
            </v-sheet>
          </template>
        </v-slider>
        <div
          class="mapContainer"
          :style="`height:750px `"
          v-click-outside="{ handler: onClickOutside }"
          @click="activeClick"
        >
          <l-map
            ref="mapRef"
            class="mapClassBorder"
            :style="
              !active ? 'border: 0px solid white' : 'border: 4px solid white'
            "
            :zoom="zoomMap"
            :center="centerMap"
            @update:zoom="changezoom($event)"
            @update:center="changeCenter($event)"
            @ready="onMapReady"
            :options="{ zoomControl: false }"
          >
            <l-control-zoom :position="'topleft'"></l-control-zoom>
            <l-control position="topright">
              <v-menu :close-on-content-click="false" location="end">
                <template v-slot:activator="{ props }">
                  <v-sheet class="iconMapButton">
                    <v-btn
                      color="black"
                      variant="text"
                      icon="mdi-menu"
                      v-bind="props"
                    ></v-btn>
                  </v-sheet>
                </template>

                <v-sheet
                  width="300"
                  max-height="550"
                  color="bgtopology"
                  class="datepickerContainer"
                >
                  <v-row v-if="!isChile" class="ma-2 mb-3">
                    <v-col class="pa-0" cols="12" sm="4" md="12">
                      <v-row class="ma-0 my-2">
                        <v-sheet
                          class="rowIcon pl-2 pt-0"
                          color="transparent"
                          height="40"
                          width="40"
                        >
                          <v-sheet
                            class="sheetNameIcon pb-1"
                            width="25"
                            height="25"
                          >
                            <v-icon size="small" color="white">{{
                              "mdi-eye"
                            }}</v-icon>
                          </v-sheet>
                        </v-sheet>
                        <v-sheet
                          color="transparent"
                          height="40"
                          class="rowName"
                        >
                          <span>{{ t("checkBoxes.showAll") }}</span>
                        </v-sheet>
                        <v-checkbox
                          v-model="showALL"
                          color="success"
                          hide-details
                        />
                      </v-row>

                      <span v-if="showALL">
                        <v-row class="ma-0 my-2">
                          <v-sheet
                            class="rowIcon"
                            color="transparent"
                            height="40"
                            width="40"
                          >
                            <img
                              :height="'25'"
                              :src="CONSTANTIMGS.IMAGES.onlyap"
                            />
                          </v-sheet>
                          <v-sheet
                            color="transparent"
                            height="40"
                            class="rowName"
                          >
                            <span>{{ t("checkBoxes.showPMPAP") }}</span>
                          </v-sheet>
                          <v-checkbox
                            v-model="showPMPAP"
                            color="success"
                            hide-details
                          />
                        </v-row>

                        <v-row class="ma-0 my-2">
                          <v-sheet
                            class="rowIcon"
                            color="transparent"
                            height="40"
                            width="40"
                          >
                            <img
                              :height="'25'"
                              :src="CONSTANTIMGS.IMAGES.onlypmp"
                            />
                          </v-sheet>
                          <v-sheet
                            color="transparent"
                            height="40"
                            class="rowName"
                          >
                            <span>{{ t("checkBoxes.showPMPSM") }}</span>
                          </v-sheet>
                          <v-checkbox
                            v-model="showPMPSM"
                            color="success"
                            hide-details
                          />
                        </v-row>

                        <v-row class="ma-0 my-2">
                          <v-sheet
                            class="rowIcon"
                            color="transparent"
                            height="40"
                            width="40"
                          >
                            <img
                              :height="'25'"
                              :src="CONSTANTIMGS.IMAGES.onlysolar"
                            />
                          </v-sheet>
                          <v-sheet
                            color="transparent"
                            height="40"
                            class="rowName"
                          >
                            <span>{{ t("checkBoxes.ShowRajant") }}</span>
                          </v-sheet>
                          <v-checkbox
                            v-model="showRajant"
                            color="success"
                            hide-details
                          />
                        </v-row>

                        <v-row class="ma-0 my-2">
                          <v-sheet
                            class="rowIcon"
                            color="transparent"
                            height="40"
                            width="40"
                          >
                            <img
                              :height="'25'"
                              :src="CONSTANTIMGS.ICONS.links"
                            />
                          </v-sheet>
                          <v-sheet
                            color="transparent"
                            height="40"
                            class="rowName"
                          >
                            <span>{{ t("checkBoxes.showLink") }}</span>
                          </v-sheet>
                          <v-checkbox
                            v-model="showPolilynesBoolean"
                            color="success"
                            hide-details
                            @update:modelValue="
                              showPolylines(showPolilynesBoolean, false)
                            "
                          />
                        </v-row>

                        <v-row class="ma-0 my-2">
                          <v-sheet
                            class="rowIcon pl-2 pt-0"
                            color="transparent"
                            height="40"
                            width="40"
                          >
                            <v-sheet
                              class="sheetNameIcon"
                              width="25"
                              height="25"
                            >
                              <span class="nameClassIcon">N</span>
                            </v-sheet>
                          </v-sheet>
                          <v-sheet
                            color="transparent"
                            height="40"
                            class="rowName"
                          >
                            <span>{{ t("checkBoxes.showNames") }}</span>
                          </v-sheet>
                          <v-checkbox
                            v-model="showNames"
                            color="success"
                            hide-details
                          />
                        </v-row>
                      </span>

                      <v-row class="ma-0 my-2">
                        <v-sheet
                          class="rowIcon"
                          color="transparent"
                          height="40"
                          width="40"
                        >
                          <img
                            :height="'25'"
                            :src="CONSTANTIMGS.ICONS.circles"
                          />
                        </v-sheet>
                        <v-sheet
                          color="transparent"
                          height="40"
                          class="rowName"
                        >
                          <span>Clusters</span>
                        </v-sheet>
                        <v-checkbox
                          v-model="showCircleCluster"
                          color="success"
                          hide-details
                        />
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-else class="ma-0 mb-3">
                    <v-col class="pa-0" cols="12" sm="4" md="12">
                      <v-checkbox
                        v-model="showNames"
                        color="success"
                        :label="t('checkBoxes.showNames')"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-menu>
            </l-control>

            <l-tile-layer :url="finalURL"></l-tile-layer>

            <span v-if="showALL">
              <l-polyline
                v-for="(item, i) in finalPolilynesANY"
                :key="i"
                :lat-lngs="item.path"
                :color="item.colorLine"
              ></l-polyline>

              <span>
                <l-polyline
                  v-for="(item, i) in finalPolilynes"
                  :key="i"
                  :lat-lngs="item.path"
                  :color="item.colorLine"
                ></l-polyline>
                <span v-if="showOnlyPMPSM">
                  <l-marker
                    v-for="(m, index) in markerspmpsm"
                    :key="index"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                    :lat-lng="m.position ?? [0, 0]"
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.onlypmp"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5>{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.name }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>
                <span v-if="showOnlyPMPAP">
                  <l-marker
                    v-for="(m, index) in markerspmpap"
                    :key="index"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                    :lat-lng="m.position ?? [0, 0]"
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img :height="'30'" :src="CONSTANTIMGS.IMAGES.onlyap" />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5 style="color: white">{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.name }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>
                <span v-if="showOnlyRajant">
                  <l-marker
                    v-for="(m, index) in markersrajant"
                    :key="index"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                    :lat-lng="m.position ?? [0, 0]"
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.onlysolar"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5>{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.name }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>

                <span v-if="showRajantwoPMPSM">
                  <l-marker
                    v-for="(m, index) in markersRajantwoPMPSM"
                    :key="index"
                    :lat-lng="m.position ?? [0, 0]"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          @click="
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          "
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.onlysolar"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5>{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.nameSM }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>
                <span v-if="showPMPSMwoRajant">
                  <l-marker
                    v-for="(m, index) in markersPMPSMwoRajant"
                    :key="index"
                    :lat-lng="m.position ?? [0, 0]"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          @click="
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          "
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.onlypmp"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5>{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.nameSM }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>
                <span v-if="showPMPAPwoRajant">
                  <l-marker
                    v-for="(m, index) in markersPMPAPwoRajant"
                    :key="index"
                    :lat-lng="m.position ?? [0, 0]"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          @click="
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          "
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.onlyap"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5>{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.nameSM }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>
                <span v-if="showPMPAPwoPMPSM">
                  <l-marker
                    v-for="(m, index) in markersPMPAPwoPMPSM"
                    :key="index"
                    :lat-lng="m.position ?? [0, 0]"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          @click="
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          "
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.onlyap"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5>{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.nameSM }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>
                <span v-if="showPMPSMwoPMPAP">
                  <l-marker
                    v-for="(m, index) in markersPMPSMwoPMPAP"
                    :key="index"
                    :lat-lng="m.position ?? [0, 0]"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          @click="
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          "
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.onlypmp"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5>{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.nameSM }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>
                <span v-if="showRajantwoPMPSMwoPMPAP">
                  <l-marker
                    v-for="(m, index) in markersRajantwoPMPSMwoPMPAP"
                    :key="index"
                    :lat-lng="m.position ?? [0, 0]"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          @click="
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          "
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.onlysolar"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5>{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.nameSM }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>
                <span v-if="showRajantwoPMPAP">
                  <l-marker
                    v-for="(m, index) in markersRajantwoPMPAP"
                    :key="index"
                    :lat-lng="m.position ?? [0, 0]"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          @click="
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          "
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.onlysolar"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5>{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.nameSM }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>

                <span v-if="showSMandRajant">
                  <l-marker
                    v-for="(m, index) in markersPMPSMwRajant"
                    :key="index"
                    :lat-lng="m.position ?? [0, 0]"
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.solarsm"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' +
                            getColorCard(m.statusSM ?? 'down')
                          "
                        >
                          <h5>{{ m.nameSM }}</h5>
                        </v-sheet>
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'mt-1 classnameIcon ' +
                            getColorCard(m.statusRAJ ?? 'down')
                          "
                        >
                          <h5>{{ m.nameRAJ }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.statusSM?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'left',
                        offset: [-35, -10],
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.statusSM ?? 'down')">
                          {{ m.nameSM }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ipSM ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                    <l-tooltip
                      v-if="m.statusRAJ?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                        offset: [30, -10],
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.statusRAJ ?? 'down')">
                          {{ m.nameRAJ }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ipRAJ ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                    <l-popup :options="{ offset: [0, -35] }">
                      <v-sheet
                        class="namePopUP"
                        width="100"
                        color="transparent"
                        @click="
                          showDialog(
                            m.ipSM ?? '',
                            m.tipoSM ?? '',
                            m.nameSM ?? '',
                            m.statusSM ?? '',
                          )
                        "
                      >
                        <span> {{ m.nameSM }} </span>
                      </v-sheet>
                      <v-sheet
                        class="mt-2 namePopUP"
                        width="100"
                        color="transparent"
                        @click="
                          showDialog(
                            m.ipRAJ ?? '',
                            m.tipoRAJ ?? '',
                            m.nameRAJ ?? '',
                            m.statusRAJ ?? '',
                          )
                        "
                      >
                        <span> {{ m.nameRAJ }} </span>
                      </v-sheet>
                    </l-popup>
                  </l-marker>
                </span>
                <span v-if="showAPandRajant">
                  <l-marker
                    v-for="(m, index) in markersRajantwPMPAP"
                    :key="index"
                    :lat-lng="m.position ?? [0, 0]"
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.apsolar"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' +
                            getColorCard(m.statusAP ?? 'down')
                          "
                        >
                          <h5>{{ m.nameAP }}</h5>
                        </v-sheet>
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'mt-1 classnameIcon ' +
                            getColorCard(m.statusRAJ ?? 'down')
                          "
                        >
                          <h5>{{ m.nameRAJ }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.statusAP?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'left',
                        offset: [-35, -10],
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.statusAP ?? 'down')">
                          {{ m.nameAP }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ipAP ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                    <l-tooltip
                      v-if="m.statusRAJ?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                        offset: [30, -10],
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.statusRAJ ?? 'down')">
                          {{ m.nameRAJ }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ipRAJ ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                    <l-popup :options="{ offset: [0, -35] }">
                      <v-sheet
                        class="namePopUP"
                        width="100"
                        color="transparent"
                        @click="
                          showDialog(
                            m.ipAP ?? '',
                            m.tipoAP ?? '',
                            m.nameAP ?? '',
                            m.statusAP ?? '',
                          )
                        "
                      >
                        <span> {{ m.nameAP }} </span>
                      </v-sheet>
                      <v-sheet
                        class="mt-2 namePopUP"
                        width="100"
                        color="transparent"
                        @click="
                          showDialog(
                            m.ipRAJ ?? '',
                            m.tipoRAJ ?? '',
                            m.nameRAJ ?? '',
                            m.statusRAJ ?? '',
                          )
                        "
                      >
                        <span> {{ m.nameRAJ }} </span>
                      </v-sheet>
                    </l-popup>
                  </l-marker>
                </span>
              </span>
              <span>
                <l-polyline
                  v-for="(item, i) in finalPolilynes"
                  :key="i"
                  :lat-lngs="item.path"
                  :color="item.colorLine"
                ></l-polyline>

                <span v-if="!showPMPSM">
                  <l-marker
                    v-for="(m, index) in markerspmpsm"
                    :key="index"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                    :lat-lng="m.position ?? [0, 0]"
                  >
                    <l-icon
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :iconSize="[60, 60]"
                      :iconAnchor="[35, 30]"
                    >
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.onlypmp"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5>{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.name }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>
                <span v-if="!showPMPAP">
                  <l-marker
                    v-for="(m, index) in markerspmpap"
                    :key="index"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                    :lat-lng="m.position ?? [0, 0]"
                  >
                    <l-icon :iconSize="[60, 60]" :iconAnchor="[35, 30]">
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img :height="'30'" :src="CONSTANTIMGS.IMAGES.onlyap" />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5 style="color: white">{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.name }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>
                <span v-if="!showRajant">
                  <l-marker
                    v-for="(m, index) in markersrajant"
                    :key="index"
                    @click="
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    "
                    :lat-lng="m.position ?? [0, 0]"
                  >
                    <l-icon
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :iconSize="[60, 60]"
                      :iconAnchor="[35, 30]"
                    >
                      <v-sheet
                        color="transparent"
                        :width="70"
                        class="text-center"
                      >
                        <img
                          :height="'30'"
                          :src="CONSTANTIMGS.IMAGES.onlysolar"
                        />
                        <v-sheet
                          v-if="showNames"
                          :class="
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          "
                        >
                          <h5>{{ m.name }}</h5>
                        </v-sheet>
                      </v-sheet>
                    </l-icon>
                    <l-tooltip
                      v-if="m.status?.toUpperCase() !== 'OK'"
                      :options="{
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }"
                    >
                      <v-sheet
                        class="sheetTooltip text-center"
                        color="#9fa09f"
                        :min-width="widthToolTip"
                      >
                        <v-sheet :color="getColorSheet(m.status ?? 'down')">
                          {{ m.name }}
                        </v-sheet>
                        <v-row
                          class="ma-0"
                          style="align-items: center"
                          justify="center"
                        >
                          <div v-html="getInfoInToMap(m.ip ?? '')" />
                        </v-row>
                      </v-sheet>
                    </l-tooltip>
                  </l-marker>
                </span>
              </span>
            </span>

          </l-map>

          <v-sheet v-if="!active" class="mapTest"></v-sheet>
        </div>
        <v-sheet
          class="mt-5"
          width="100%"
          color="transparent"
          style="align-content: center"
        >
          <v-row class="ma-0" :justify="smAndDown ? 'center' : 'space-between'">
            <!-- <v-col sm="12" md="12" lg="3" class="pa-0"> -->
              <v-sheet color="transparent" :width="mdAndDown ? '100%' : 360">
                <v-row class="ma-0" :justify="mdAndDown ? 'center' : 'start'">
                  <v-icon> mdi-speedometer </v-icon>
                  <span class="ml-2 mt-0 legendMapDash">
                    {{ t("labels.latency") }} |
                    <span> {{ t("labels.redSpeed") }}</span>
                  </span>
                </v-row>
              </v-sheet>
            <!-- </v-col> -->
            <rangeComponent
              :class="smAndDown ? 'mt-2' : 'mt-0'"
              :principal-color="COLOR.green"
              :secundary-color="'rgb(62 97 57)'"
              :color-text-princ="'white'"
              :color-text-secun="'white'"
              :principal-text="t('labels.ok')"
              :secundary-text="'0 a 100 ms'"
              :sheetWidth="smAndDown ? 350 : 225"
            />
            <rangeComponent
              :class="smAndDown ? 'mt-2' : 'mt-0'"
              :principal-color="COLOR.yellow"
              :secundary-color="'#B4A343'"
              :color-text-princ="'black'"
              :color-text-secun="'white'"
              :principal-text="t('labels.alert')"
              :secundary-text="'100 a 500 ms'"
              :sheetWidth="smAndDown ? 350 : 225"
            />
            <rangeComponent
              :class="smAndDown ? 'mt-2' : 'mt-0'"
              :principal-color="COLOR.red"
              :secundary-color="'#8F3A36'"
              :color-text-princ="'white'"
              :color-text-secun="'white'"
              :principal-text="t('labels.alarm')"
              :secundary-text="'Mayor a 500 ms'"
              :sheetWidth="smAndDown ? 350 : 225"
            />
          </v-row>
        </v-sheet>
      </div>

      <v-sheet
        v-if="showFilters"
        color="transparent"
        :class="mdAndDown ? 'pa-0 pt-4' : 'pl-4'"
        :style="mdAndDown ? 'text-align: -webkit-center;' : ''"
        :width="mdAndDown ? '100%' : width"
      >
        <MessageComponent />
      </v-sheet>
    </v-row>
  </v-sheet>
  <v-dialog v-model="dialog" width="85%">
    <DialogComponent
      v-if="dialog"
      :ip="selectedIp"
      :typeSel="selectedType"
      :name="selectedName"
      :status="finalStatus"
      @dialog="closeDialog"
    />
  </v-dialog>
</template>

<script setup lang="ts">
import {
  Ref,
  computed,
  onMounted,
  ref,
  watch,
  onBeforeUnmount,
  toRaw
} from "vue";
import axios from "axios";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
const { smAndDown, mdAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from "vue-i18n";
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
const store = useStore();

/********************************
 ********** COMPONENTS **********
 *******************************/
import MessageComponent from "@/components/SmartLink/dashboard/MessageComponent.vue";
import DialogComponent from "@/components/SmartLink/dialog/dialogComponent.vue";
import rangeComponent from "@/components/SmartLink/dashboard/rangeComponent.vue";

/********************************
 *********** LEAFTLET ***********
 *******************************/
import {
  LMap,
  LTileLayer,
  LPolyline,
  LPopup,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
  LControl /*LHeatLayer*/,
} from "@vue-leaflet/vue-leaflet";
import "/public/leaflet/leaflet.css";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
if (typeof window !== "undefined") {
  window.L = L;
}
import "leaflet.heat"; // Importamos DESPUÉS de definir window.L

/********************************
 ********** CONSTANTES **********
 *******************************/
import {
  LABELS,
  NAME_PROJECT,
  STRING_GENERAL,
  TOKEN,
} from "@/constants/labels";
import { TIMEOUTTIME } from "@/constants/apis";
import CONSTANTIMGS from "@/constants/images";
import { COLOR } from "@/constants/colors";
import CONSTMAPS from "@/constants/maps";
import CONSTAPIS from "@/constants/apis";

/********************************
 ********** INTERFACES **********
 *******************************/
import { POSITION, CIRCLE, CLUSTERING } from "@/interfaces/SmartLink/Map";
import { TOPO_ITEMS } from "@/interfaces/SmartLink/Topology";
import { EQUIPAMENTS } from "@/interfaces/SmartLink/Equips";
import { STRINGS } from "@/interfaces/SmartLink/General";
import { PointExpression } from "leaflet";

/********************************
 *********** FUNCTION ***********
 *******************************/
import {
  getStatusByLatency,
  getStatusBySNR,
  getStatusByRXLVL,
  getFinalStatusByStatitics,
} from "@/functions/maps";
import {
  getLastRXLVLandSNR,
  getAllLatencyLast,
  getAllHexagon,
} from "@/services/Smartlink/Map";
import { showConsoleError } from "@/functions/errors";

const pointsClustering: Ref<CLUSTERING[]> = ref([]);

const mapInstance:any = ref(null);
let heatLayer: any = null; // Aquí guardamos la capa de calor

// Esta función se dispara cuando Leaflet termina de cargar
const onMapReady = (mapObject: any) => {
  // Guardamos la instancia del mapa para usarla con Javascript puro
  mapInstance.value = mapObject;
};

const actualizarHeatmap = async () => {
  // Seguridad: Si el mapa no ha cargado, no hacemos nada
  if (!mapInstance.value) return;

  // Obtenemos el objeto 'crudo' de Leaflet (sin proxys de Vue)
  const map: any = toRaw(mapInstance.value);

  // 1. Limpiamos la capa anterior si existe
  if (heatLayer) {
    map.removeLayer(heatLayer);
  }

  const puntosCalor: any[] = [];

  // 2. Preparamos los datos: [lat, lng, intensidad]
  pointsClustering.value.forEach((p: any) => {
    if (p.latitud !== 0 && p.longitud !== 0) {
      puntosCalor.push([p.latitud, p.longitud, .3]);
    }
  });

  // 3. Creamos la capa con leaflet.heat
  heatLayer = L.heatLayer(puntosCalor, {
    radius: 17, // Radio de cada punto
    blur: 2, // Difuminado
    maxZoom: 15,
    gradient: { 0.6: "yellow", 1: "red" },
  });

  // 4. Añadimos al mapa
  map.addLayer(heatLayer);
};

// --- REACTIVIDAD ---
// Si tus datos cambian (se mueve el ScrollBar), redibujamos
watch(
  pointsClustering,
  () => {
    actualizarHeatmap();
  },
  { deep: true },
);

// Limpieza al salir
onBeforeUnmount(() => {
  if (mapInstance.value && heatLayer) {
    const map: any = toRaw(mapInstance.value);
    map.removeLayer(heatLayer);
  }
});

const active = ref(false);

const onClickOutside = () => {
  active.value = false;
};

const activeClick = () => {
  active.value = true;
};

const projectName = computed(() => store.state.projectName);

const isChile = ref(
  projectName.value === "SmartLinkAntucoya" ||
    projectName.value === "SmartLinkZaldivar",
);
const finalURL = ref("");

const width = ref("350");
const widthToolTip = ref("100");
const markerspmpsm: Ref<any[]> = ref([]);

const zoomMap = computed(() => CONSTMAPS.zoom.value);
const centerMap: Ref<PointExpression> = ref([
  CONSTMAPS.latitud.value,
  CONSTMAPS.longitud.value,
]);

const markersPMPSMwRajant: Ref<any[]> = ref([]);
const markersPMPSMwPMPAP: Ref<any[]> = ref([]);
const markersPMPAPwRajant: Ref<any[]> = ref([]);
const markersPMPAPwPMPSM: Ref<any[]> = ref([]);
const markersRajantwPMPAP: Ref<any[]> = ref([]);
const markersRajantwPMPSM: Ref<any[]> = ref([]);

const markersPMPSMwoRajant: Ref<any[]> = ref([]);
const markersPMPSMwoPMPAP: Ref<any[]> = ref([]);
const markersRajantwoPMPSM: Ref<any[]> = ref([]);
const markersRajantwoPMPAP: Ref<any[]> = ref([]);
const markersPMPAPwoRajant: Ref<any[]> = ref([]);
const markersPMPAPwoPMPSM: Ref<any[]> = ref([]);

const markersRajantwoPMPSMwoPMPAP: Ref<any[]> = ref([]);

const ipMatchPMPSMwPMPAP: Ref<string[]> = ref([]);
const ipMatchPMPSMwRajant: Ref<string[]> = ref([]);
const ipMatchRajantwPMPAP: Ref<string[]> = ref([]);

const markerspmpap: Ref<any> = ref([]);
const dialog = ref(false);
const selectedIp = ref("");
const selectedName = ref("");
const selectedType = ref("");
const elementPMPSM: Ref<EQUIPAMENTS[]> = ref([]);
const elementRAJANT: Ref<EQUIPAMENTS[]> = ref([]);
const markersrajant: Ref<any[]> = ref([]);
const toPMPAP: Ref<any> = ref({});
const polilynes: Ref<any> = ref([]);
const finalPolilynes = ref(polilynes.value);
const polilynesANY: Ref<any> = ref([]);
const finalPolilynesANY = ref(polilynesANY.value);
const finalStatus = ref("Ok");

watch(smAndDown, (valor: boolean) => {
  valor ? (width.value = "100%") : (width.value = "350");
});

const COLORSTATUS: STRINGS = {
  OK: "green",
  ALERT: "yellow",
  ALARM: "red",
  DOWN: "#353634",
};

//==================================================//
//===================== METHODS ====================//
//==================================================//

/**
 * Format Color in Polylines
 * @param color
 */
const optionsRect = (status: string, position: POSITION[]) => {
  let color = COLORSTATUS[status];

  return {
    path: position,
    colorLine: color,
    geodesic: true,
    strokeColor: color,
    strokeOpacity: 0.8,
    strokeWeight: 3,
    fillColor: color,
    fillOpacity: 0.8,
  };
};

const matchPMPSMWithAny = async () => {
  let i = 0.00003;

  elementPMPSM.value.forEach((pmpsm: EQUIPAMENTS) => {
    i = i + 0.00003;
    const ipRaj = ref("");
    const typeRaj = ref("");
    const finalPosition = ref([0, 0]);
    const equipFindRAJ = ref(false);
    const nameRaj = ref("");
    let anotacion =
      pmpsm.anotacion !== null ? JSON.parse(pmpsm.anotacion ?? "{}") : {};
    if (anotacion.gps) {
      markersrajant.value.find(({ ip, position }) => {
        if (anotacion.gps == ip) {
          finalPosition.value = position;
        }
      });
    } else {
      if (pmpsm.latitud && pmpsm.longitud) {
        finalPosition.value = [pmpsm.latitud, pmpsm.longitud];
      }

      elementRAJANT.value.find(
        ({ name, latitud, longitud, ip, tipo }: EQUIPAMENTS) => {
          if (name && latitud && longitud) {
            let firstName = "";
            let secondName = "";

            if (
              projectName.value === NAME_PROJECT.cananea ||
              projectName.value === NAME_PROJECT.demo ||
              projectName.value === NAME_PROJECT.nacozari
            ) {
              firstName = name.split("-")[0];
              secondName = pmpsm.name?.split("M")[1] ?? "";
            }
            if (projectName.value === NAME_PROJECT.collahuasi) {
              firstName = name.split("-")[2];
              secondName = pmpsm.name?.split("-")[3] ?? "";
            }
            if (firstName === secondName) {
              equipFindRAJ.value = true;
              let finalPositions = [latitud, longitud];
              finalPosition.value = finalPositions;
              nameRaj.value = name;
              ipRaj.value = ip ?? "";
              typeRaj.value = tipo ?? "";
            }
          }
        },
      );
    }

    markerspmpsm.value.push({
      position: finalPosition.value,
      name: pmpsm.name,
      ip: pmpsm.ip,
      tipo: pmpsm.tipo,
      padre: pmpsm.padre,
      status: getStatusByIP(pmpsm.ip ?? ""),
    });

    if (equipFindRAJ.value) {
      markersPMPSMwRajant.value.push({
        position: finalPosition.value,
        nameSM: pmpsm.name,
        ipSM: pmpsm.ip,
        tipoSM: pmpsm.tipo,
        statusSM: getStatusByIP(pmpsm.ip ?? ""),
        nameRAJ: nameRaj.value,
        ipRAJ: ipRaj.value,
        tipoRAJ: typeRaj.value,
        statusRAJ: getStatusByIP(ipRaj.value ?? ""),
      });
      ipMatchPMPSMwRajant.value.push(ipRaj.value);
    } else {
      markersPMPSMwoRajant.value.push({
        position: finalPosition.value,
        name: pmpsm.name,
        ip: pmpsm.ip,
        tipo: pmpsm.tipo,
        padre: pmpsm.padre,
        status: getStatusByIP(pmpsm.ip ?? ""),
      });
    }
    let finalposition = finalPosition.value;
    const equipFindPMPAP = ref(false);

    markerspmpap.value.find(({ position, name, ip, tipo, status }: any) => {
      if (
        finalposition[0] - position[0] <= 0.0005 &&
        finalposition[0] - position[0] >= -0.0005
      ) {
        equipFindPMPAP.value = true;
        markersPMPSMwPMPAP.value.push({
          position: position,
          nameAP: name,
          ipAP: ip,
          tipoAP: tipo,
          statusAP: status,
          namePMPSM: pmpsm.name,
          ipPMPSM: pmpsm.ip,
          tipoPMPSM: pmpsm.tipo,
          statusPMPSM: getStatusByIP(pmpsm.ip ?? ""),
        });
        ipMatchPMPSMwPMPAP.value.push(pmpsm.ip ?? "");
      }
    });

    if (!equipFindPMPAP.value) {
      markersPMPSMwoPMPAP.value.push({
        position: finalPosition,
        name: pmpsm.name,
        ip: pmpsm.ip,
        tipo: pmpsm.tipo,
        status: getStatusByIP(pmpsm.ip ?? ""),
      });
    }
  });
};

const matchRajantWithAny = async () => {
  markersrajant.value.forEach((rajant: any) => {
    const equipFindPMPAP = ref(false);
    if (!ipMatchPMPSMwRajant.value.includes(rajant.ip)) {
      markersRajantwoPMPSM.value.push({
        position: rajant.position,
        name: rajant.name,
        ip: rajant.ip,
        tipo: rajant.tipo,
        status: getStatusByIP(rajant.ip ?? ""),
      });
    } else {
      markersRajantwPMPSM.value.push({
        position: rajant.position,
        name: rajant.name,
        ip: rajant.ip,
        tipo: rajant.tipo,
        status: getStatusByIP(rajant.ip ?? ""),
      });
    }

    markerspmpap.value.find(({ position, name, ip, tipo, status }: any) => {
      if (
        rajant.position[0] - position[0] <= 0.0005 &&
        rajant.position[0] - position[0] >= -0.0005
      ) {
        equipFindPMPAP.value = true;
        markersRajantwPMPAP.value.push({
          position: position,
          nameAP: name,
          ipAP: ip,
          tipoAP: tipo,
          statusAP: status,
          nameRAJ: rajant.name,
          ipRAJ: rajant.ip,
          tipoRAJ: rajant.tipo,
          statusRAJ: getStatusByIP(rajant.ip ?? ""),
        });
        ipMatchRajantwPMPAP.value.push(rajant.ip);
      }
    });
    if (!equipFindPMPAP.value) {
      markersRajantwoPMPAP.value.push({
        position: rajant.position,
        name: rajant.name,
        ip: rajant.ip,
        tipo: rajant.tipo,
        status: getStatusByIP(rajant.ip ?? ""),
      });
    }
  });
};

const matchRajantwithoutANY = async () => {
  markersRajantwoPMPSM.value.forEach((rajwosm: any) => {
    markersRajantwoPMPAP.value.find(({ ip }) => {
      if (rajwosm.ip === ip) {
        markersRajantwoPMPSMwoPMPAP.value.push(rajwosm);
      }
    });
  });
};

const matchPMPAPwithAny = async () => {
  markerspmpap.value.forEach((pmpap: any) => {
    const equipFindRajant = ref(false);

    markersrajant.value.find(({ ip, name, position, tipo, status }: any) => {
      if (
        pmpap.position[0] - position[0] <= 0.0005 &&
        pmpap.position[0] - position[0] >= -0.0005
      ) {
        equipFindRajant.value = true;
        markersPMPAPwRajant.value.push({
          position: position,
          nameRAJ: name,
          ipRAJ: ip,
          tipoRAJ: tipo,
          statusRAJ: status,
          nameAP: pmpap.name,
          ipAP: pmpap.ip,
          tipoAP: pmpap.tipo,
          statusAP: getStatusByIP(pmpap.ip ?? ""),
        });
      }
    });

    if (!equipFindRajant.value) {
      markersPMPAPwoRajant.value.push(pmpap);
    }

    markerspmpsm.value.find(({ ip, name, position, tipo }: any) => {
      if (
        pmpap.position[0] - position[0] <= 0.0005 &&
        pmpap.position[0] - position[0] >= -0.0005
      ) {
        markersPMPAPwPMPSM.value.push({
          position: position,
          nameSM: name,
          ipSM: ip,
          tipoSM: tipo,
          statusSM: getStatusByIP(ip ?? ""),
          nameAP: pmpap.name,
          ipAP: pmpap.ip,
          tipoAP: pmpap.tipo,
          statusAP: getStatusByIP(pmpap.ip ?? ""),
        });
      }
    });

    if (!ipMatchPMPSMwPMPAP.value.includes(pmpap.ip)) {
      markersPMPAPwoPMPSM.value.push(pmpap);
    }
  });
};

/**
 * Get PMPSM Data
 */
const getLatLongPMPSM = async () => {
  await axios
    .get(CONSTAPIS.APIS.value.maps.getAllLatLngSM, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      if (
        projectName.value === NAME_PROJECT.cananea ||
        projectName.value === NAME_PROJECT.hcg ||
        projectName.value === NAME_PROJECT.demo ||
        projectName.value === NAME_PROJECT.collahuasi ||
        projectName.value === NAME_PROJECT.nacozari
      ) {
        elementPMPSM.value = response.data;
      }
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

const getAllIEOByIP = ref([{ ip: "", ok: 0, alarm: 0, alert: 0, down: 0 }]);

const getAllOperabilityLastDay = async () => {
  await axios
    .get(CONSTAPIS.APIS.value.topology.getAllOpLastDay, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((element) => {
      getAllIEOByIP.value = element.data;
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

function getInfoInToMap(ip: string) {
  let htmlInMap = "";

  const latency = allFinalStatiticsItems.value[ip].latenciaValue;
  const rxlvl = allFinalStatiticsItems.value[ip].rxlvlValue;
  const snrh = allFinalStatiticsItems.value[ip].snrhValue;
  const snrv = allFinalStatiticsItems.value[ip].snrvValue;

  if (rxlvl && snrh && snrv) {
    htmlInMap = `
        <p>Latencia : ${latency}ms</p>
        <p>RXLVL : ${rxlvl}dBm</p>
        <p>SNRH : ${snrh}dB</p>
        <p>SNRV : ${snrv}dB</p>
        `;
  } else {
    htmlInMap = `
        <p>Latencia : ${latency}ms</p>
        `;
  }

  return htmlInMap;
}

const getColorSheet = (status: string) => {
  let colorSheet = "";
  if (status.toUpperCase() === "OK") {
    colorSheet = "green";
  }
  if (status.toUpperCase() === "ALERT") {
    colorSheet = "yellow";
  }
  if (status.toUpperCase() === "ALARM") {
    colorSheet = "red";
  }
  if (status.toUpperCase() === "DOWN") {
    colorSheet = "#505150";
  }
  return colorSheet;
};
const getColorCard = (status: string) => {
  let colorSheet = "";
  if (status.toUpperCase() === "OK") {
    colorSheet = "greenSheet";
  }
  if (status.toUpperCase() === "ALERT") {
    colorSheet = "yellowSheet";
  }
  if (status.toUpperCase() === "ALARM") {
    colorSheet = "redSheet";
  }
  if (status.toUpperCase() === "DOWN") {
    colorSheet = "greySheet";
  }
  return colorSheet;
};

const showPolilynesBoolean = ref(false);
const showTimeLineClustering = ref(false);
const showNames = ref(true);
const showClusterChBox = ref(true);
const showCircleCluster = ref(true);
const showRajant = ref(false);
const showALL = ref(true);
const showPMPSM = ref(false);
const showPMPAP = ref(false);

const showInfoMapCheckBoxes = computed(() => store.state.showInfoMap);

const showOnlyNotOk = ref(true);

const showOnlyPMPAP = ref(false);
const showOnlyPMPSM = ref(false);
const showOnlyRajant = ref(false);

const showSMandRajant = ref(true);
const showSMandAP = ref(true);
const showAPandRajant = ref(true);
const showAPandSM = ref(true);
const showRajantandAP = ref(true);
const showRajantandSM = ref(true);

const showRajantwoPMPSM = ref(true);
const showRajantwoPMPAP = ref(true);
const showPMPSMwoRajant = ref(true);
const showPMPSMwoPMPAP = ref(true);
const showRajantwoPMPSMwoPMPAP = ref(true);
const showPMPAPwoPMPSM = ref(true);
const showPMPAPwoRajant = ref(true);

const showFilters = ref(true);

const allFinalItems: any = ref({});

const getAllStatusAndLocation = async () => {
  markerspmpap.value.forEach((item: any) => {
    if (!allFinalItems.value[item.ip]) {
      allFinalItems.value[item.ip] = {};
    }
    allFinalItems.value[item.ip] = {
      position: item.position,
      status: item.status,
    };
  });

  markerspmpsm.value.forEach((item: any) => {
    if (!allFinalItems.value[item.ip]) {
      allFinalItems.value[item.ip] = {};
    }
    allFinalItems.value[item.ip] = {
      position: item.position,
      status: item.status,
    };
  });

  markersrajant.value.forEach((item: any) => {
    if (!allFinalItems.value[item.ip]) {
      allFinalItems.value[item.ip] = {};
    }
    allFinalItems.value[item.ip] = {
      position: item.position,
      status: item.status,
    };
  });
};

const allFinalStatiticsItems: any = ref({});

async function getAllRXLVLSNR() {
  const allData = await getLastRXLVLandSNR();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    allData.data.forEach((item: any) => {
      if (allFinalStatiticsItems.value[item.ip]) {
        allFinalStatiticsItems.value[item.ip].snrv = getStatusBySNR(item.snrv);
        allFinalStatiticsItems.value[item.ip].snrh = getStatusBySNR(item.snrh);
        allFinalStatiticsItems.value[item.ip].rxlvl = getStatusByRXLVL(
          item.rxlvl,
        );
        allFinalStatiticsItems.value[item.ip].txlvl = getStatusByRXLVL(
          item.rxlvl,
        );
        allFinalStatiticsItems.value[item.ip].snrvValue = item.snrv;
        allFinalStatiticsItems.value[item.ip].snrhValue = item.snrh;
        allFinalStatiticsItems.value[item.ip].rxlvlValue = item.rxlvl;
      }
    });
  }
}

async function getAllFinalLatency() {
  const allData = await getAllLatencyLast();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    const finalData = allData.data;

    finalData.forEach((item: any) => {
      if (!allFinalStatiticsItems.value[item.ip]) {
        allFinalStatiticsItems.value[item.ip] = {};
      }
      allFinalStatiticsItems.value[item.ip].latencia = getStatusByLatency(
        item.latencia,
      );
      allFinalStatiticsItems.value[item.ip].latenciaValue = item.latencia;
      allFinalStatiticsItems.value[item.ip].fecha = item.fecha;
    });
  }
}

const allFinalStatusItems: any = ref({});

function getStatusByIP(ip: string) {
  if (!allFinalStatusItems.value[ip]) {
    return "down";
  }
  return allFinalStatusItems.value[ip].status;
}

const getAllPolylines = async () => {
  await getAllStatusAndLocation();

  await axios
    .get(CONSTAPIS.APIS.value.maps.getAllPolylines, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((resp) => {
      let allRelations = resp.data;
      allRelations.forEach((item: any) => {
        let positionPadre = allFinalItems.value[item.ip_fuente]
          ? allFinalItems.value[item.ip_fuente].position
          : [0, 0];
        let positionHijo = allFinalItems.value[item.ip_cliente]
          ? allFinalItems.value[item.ip_cliente].position
          : [0, 0];
        let statusHijo = allFinalItems.value[item.ip_cliente]
          ? allFinalItems.value[item.ip_cliente].status
          : "down";

        let finalStatus = statusHijo;

        let finalposition = [positionPadre, positionHijo];

        polilynes.value.push(optionsRect(finalStatus, finalposition));
      });
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

const showPolylines = async (isShow: boolean, isOnlyAlert: boolean) => {
  if (!isShow) {
    finalPolilynes.value = [];
    showPMPSM.value = false;
  } else {
    let prePolylines: any[] = [];
    polilynes.value.forEach((polilyne: any) => {
      if (polilyne.colorLine) {
        if (isOnlyAlert) {
          polilyne.colorLine.toUpperCase() !== "GREEN"
            ? prePolylines.push(polilyne)
            : null;
        } else {
          prePolylines.push(polilyne);
          showPMPSM.value = true;
        }
      }
    });
    finalPolilynes.value = prePolylines;
    store.commit("setLineMapCheckBoxes", isOnlyAlert);
  }
};

const getLatLongRAJANT = async () => {
  await axios
    .get(CONSTAPIS.APIS.value.maps.getAllLatLngRAJ, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      elementRAJANT.value = response.data;

      elementRAJANT.value.forEach((element: EQUIPAMENTS) => {
        const latitud = element.latitud;
        const longitud = element.longitud;
        let position = [latitud, longitud];

        markersrajant.value.push({
          position: position,
          label: element.name,
          name: element.name,
          ip: element.ip,
          tipo: element.tipo,
          status: getStatusByIP(element.ip ?? ""),
        });
      });
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

// const getStatusEquipment = (ipstring:string) => {
//     let finalStatusEquipment = 'ok';

//     statusMarkers.value.find(({ip,status}:any) => {
//         if(ipstring === ip) finalStatusEquipment = status
//     });

//     return finalStatusEquipment;
// }

/**
 * Get PMPAP Data
 */
const getLatLongPMPAP = async () => {
  await axios
    .get(CONSTAPIS.APIS.value.maps.getAllLatLngAP, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      let itemsLatLng = response.data;
      itemsLatLng.forEach((element: EQUIPAMENTS) => {
        let finalLatitud = 0;
        let finalLongitud = 0;
        let finalPosition = [finalLatitud, finalLongitud];
        let equipName = element.name;
        let anotacion =
          element.anotacion !== null
            ? JSON.parse(element.anotacion ?? "{}")
            : {};
        if (anotacion.gps) {
          markersrajant.value.find(({ ip, position }) => {
            if (anotacion.gps == ip) {
              finalPosition = position;
            }
          });
        } else {
          let gps =
            element.gps !== null
              ? JSON.parse(element.gps ?? '{"latitud":0, "longitud":0}')
              : { latitud: 0, longitud: 0 };
          finalLatitud = gps.latitud;
          finalLongitud = gps.longitud;
          if (
            element.name?.includes(STRING_GENERAL.PMPAP1) ||
            element.name?.includes(STRING_GENERAL.PMPAP5)
          ) {
            (finalLatitud = element.longitud ?? 0 + 0.000512),
              (finalLongitud = element.latitud ?? 0 - 0.000512);
          }
          finalPosition = [finalLatitud, finalLongitud];

          if (element.ip !== undefined) {
            toPMPAP.value[element.ip] = finalPosition;
          }
        }

        markerspmpap.value.push({
          position: finalPosition,
          name: `${equipName}`,
          ip: element.ip,
          tipo: element.tipo,
          status: getStatusByIP(element.ip ?? ""),
        });
      });
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

const circles: Ref<any> = ref([]);
const allCircles: Ref<any[]> = ref([]);
const allCirclesFiltered: Ref<CIRCLE[]> = ref([]);
const arrayDatesCircle: Ref<string[]> = ref([]);
const modelSliderStatus: Ref<number[]> = ref([0, 12]);

watch(modelSliderStatus, (a: number[], b: number[]) => {
  if (JSON.stringify(a) !== JSON.stringify(b))
    showCircles(arrayDatesCircle.value[a[0]], arrayDatesCircle.value[b[1]]);
});

const showCircles = async (firstDate: string, lastDate: string) => {
  circles.value = [];
  allCirclesFiltered.value.forEach((circle: CIRCLE) => {
    if (
      circle.fecha &&
      new Date(circle.fecha).getTime() <= new Date(lastDate).getTime() &&
      new Date(circle.fecha).getTime() >= new Date(firstDate).getTime()
    ) {
      circles.value.push(circle);
    }
  });
};

/**
 * When click in Item, show Dialog Component
 */
const showDialog = (ip: string, type: string, name: string, status: string) => {
  dialog.value = !dialog.value;
  selectedName.value = name;
  selectedIp.value = ip;
  selectedType.value = type;
  finalStatus.value = status;
};

const closeDialog = (value: boolean) => {
  dialog.value = value;
};

const latAlarm: Ref<any> = ref([]);
const latAlert: Ref<any> = ref([]);
const totalClusteringData: Ref<CLUSTERING[]> = ref([]);
const valueSliderMap = ref(12);
const arrayDatesClustering: Ref<string[]> = ref([]);

const get12HoursByClustering = async () => {
  await axios
    .get(CONSTAPIS.APIS.value.ia.get12HourCluster, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((resp) => {
      let arrayFechas = resp.data;
      arrayFechas.forEach((item: CLUSTERING) => {
        arrayDatesClustering.value.push(item.fecha ?? "01/01/1900");
      });
      arrayDatesClustering.value.sort();
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

const getClusteringMap = async () => {
  let params = {
    fecha: arrayDatesClustering.value[0],
  };

  await axios
    .get(CONSTAPIS.APIS.value.ia.getClusterData, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((resp) => {
      totalClusteringData.value = resp.data;

      if (totalClusteringData.value.length > 0) {
        getFilterByHours(
          arrayDatesClustering.value[arrayDatesClustering.value.length - 1],
        );
        showClusterChBox.value = false;
      } else {
        showClusterChBox.value = true;
      }
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

function getFilterByHours(fechas: string) {
  let arrayTotal = totalClusteringData.value;
  let finalArray: CLUSTERING[] = [];
  arrayTotal.forEach((element: CLUSTERING) => {
    if (
      element.fecha &&
      new Date(element.fecha).getTime() == new Date(fechas).getTime()
    ) {
      finalArray.push(element);
    }
  });
  pointsClustering.value = finalArray;
  // getClusteringByHours(finalArray);
}

const getClusteringByHours = (arrayProv: CLUSTERING[]) => {
  latAlarm.value = [];
  latAlert.value = [];
  let princAlert: CLUSTERING[] = [];
  let princAlarm: CLUSTERING[] = [];

  arrayProv.forEach((item: CLUSTERING) => {
    if (item.label === 3) {
      princAlert.push(item);
      let latitud = item.latitud ?? 0;
      let longitud = item.longitud ?? 0;
      latAlert.value.push({
        position: [latitud, longitud],
      });
    }
    if (item.label === 4) {
      princAlarm.push(item);
      let latitud = item.latitud ?? 0;
      let longitud = item.longitud ?? 0;
      latAlarm.value.push({
        position: [latitud, longitud],
      });
    }
  });
};

const season = (val: number) => {
  let finalDate = arrayDatesClustering.value[val - 1];
  return finalDate;
};

const addHours = () => {
  if (valueSliderMap.value < 12) valueSliderMap.value++;
};

const deleteHours = () => {
  if (valueSliderMap.value > 1) valueSliderMap.value--;
};

const hideALL = () => {
  showOnlyPMPAP.value = false;
  showOnlyPMPSM.value = false;
  showRajantwoPMPSMwoPMPAP.value = false;
  showOnlyRajant.value = false;

  showSMandRajant.value = false;
  showRajantwoPMPSM.value = false;
  showSMandAP.value = false;
  showRajantwoPMPAP.value = false;
  showAPandRajant.value = false;
  showPMPSMwoRajant.value = false;
  showAPandSM.value = false;
  showPMPSMwoPMPAP.value = false;
  showRajantandAP.value = false;
  showPMPAPwoPMPSM.value = false;
  showRajantandSM.value = false;
  showPMPAPwoRajant.value = false;
};

const showMarkerFunction = async (showitems: string) => {
  let functOBJ = showitems === "" ? "hideALL" : showitems;

  const functionsItems: any = {
    SM: () => {
      hideALL();
      showOnlyPMPSM.value = true;
    },
    AP: () => {
      hideALL();
      showOnlyPMPAP.value = true;
    },
    RAJ: () => {
      hideALL();
      showOnlyRajant.value = true;
    },
    SMAP: () => {
      hideALL();
      showSMandAP.value = true;
      showPMPSMwoPMPAP.value = true;
      showPMPAPwoPMPSM.value = true;
    },
    APRAJ: () => {
      hideALL();
      showAPandRajant.value = true;
      showRajantwoPMPAP.value = true;
      showPMPAPwoRajant.value = true;
    },
    SMRAJ: () => {
      hideALL();
      showSMandRajant.value = true;
      showPMPSMwoRajant.value = true;
      showRajantwoPMPSM.value = true;
    },
    SMAPRAJ: () => {
      hideALL();
      showSMandRajant.value = true;
      showSMandAP.value = true;
      showPMPSMwoRajant.value = true;
      showAPandRajant.value = true;
      showPMPAPwoRajant.value = true;
      showRajantwoPMPSMwoPMPAP.value = true;
    },
    hideALL: () => {
      hideALL();
      showPolylines(true, true);
    },
  };
  functionsItems[functOBJ]();
};

async function getCheckBoxes() {
  showPMPSM.value = showInfoMapCheckBoxes.value.includes("SM");
  showPMPAP.value = showInfoMapCheckBoxes.value.includes("AP");
  showRajant.value = showInfoMapCheckBoxes.value.includes("RAJ");
}

watch(valueSliderMap, (v: number) => {
  let dateSelected = arrayDatesClustering.value[v - 1];
  getFilterByHours(dateSelected);
});

watch(showRajant, (getBoolean: boolean) => {
  let getRaj = getBoolean ? "RAJ" : "";
  let getSM = showPMPSM.value ? "SM" : "";
  let getAP = showPMPAP.value ? "AP" : "";

  let finalObj = `${getSM}${getAP}${getRaj}`;
  store.commit("setInfoMapCheckBoxes", finalObj);
  showMarkerFunction(finalObj);
});
watch(showPMPSM, (getBoolean: boolean) => {
  let getRaj = showRajant.value ? "RAJ" : "";
  let getSM = getBoolean ? "SM" : "";
  let getAP = showPMPAP.value ? "AP" : "";

  let finalObj = `${getSM}${getAP}${getRaj}`;
  store.commit("setInfoMapCheckBoxes", finalObj);
  showMarkerFunction(finalObj);
});

watch(showPMPAP, (getBoolean: boolean) => {
  let getRaj = showRajant.value ? "RAJ" : "";
  let getSM = showPMPSM.value ? "SM" : "";
  let getAP = getBoolean ? "AP" : "";

  let finalObj = `${getSM}${getAP}${getRaj}`;
  store.commit("setInfoMapCheckBoxes", finalObj);
  showMarkerFunction(finalObj);
});

watch(showOnlyNotOk, (getBoolean: boolean) => {
  showRajant.value = !getBoolean;
  showPMPSM.value = !getBoolean;
  showPMPAP.value = !getBoolean;
  showPolilynesBoolean.value = !getBoolean;
  showPolylines(true, getBoolean);
});

const changezoom = (e: number) => {
  store.commit("setProjectZOOM", e);
};

const changeCenter = (center: any) => {
  store.commit("setProjectLAT", center.lat);
  store.commit("setProjectLNG", center.lng);
};

async function resetAllInfo() {
  markerspmpsm.value = [];
  markerspmpap.value = [];
  markersrajant.value = [];
  markersPMPSMwRajant.value = [];
  markersPMPSMwoRajant.value = [];
  markersPMPSMwPMPAP.value = [];
  markersPMPSMwoPMPAP.value = [];
  markersRajantwPMPSM.value = [];
  markersRajantwoPMPSM.value = [];
  markersRajantwPMPAP.value = [];
  markersRajantwoPMPAP.value = [];
  markersPMPAPwRajant.value = [];
  markersPMPAPwoRajant.value = [];
  markersPMPAPwPMPSM.value = [];
  markersPMPAPwoPMPSM.value = [];
  polilynes.value = [];
  finalPolilynes.value = [];
  allFinalStatiticsItems.value = {};
  allFinalStatusItems.value = {};
  toPMPAP.value = {};
  circles.value = [];
  allCircles.value = [];
  allCirclesFiltered.value = [];
  arrayDatesCircle.value = [];
  latAlarm.value = [];
  latAlert.value = [];
}

async function getAllInfo() {
  await getAllFinalLatency();
  await getAllRXLVLSNR();
  allFinalStatusItems.value = await getFinalStatusByStatitics(
    allFinalStatiticsItems.value,
  );
  await getAllOperabilityLastDay();
  await getLatLongRAJANT();
  await getLatLongPMPAP();
  await getLatLongPMPSM();
  await matchPMPSMWithAny();
  await matchRajantWithAny();
  await matchRajantwithoutANY();
  await matchPMPAPwithAny();
  await showMarkerFunction(showInfoMapCheckBoxes.value);
  await getCheckBoxes();
  await getAllPolylines();
  await showPolylines(true, true);
}

let geoJsonLayer: any = null;

async function getInfoHexagonInMap() {

  const allData:any = await getAllHexagon()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
      const finalData = allData.data;
      geoJsonLayer = L.geoJSON(finalData, {
        style: (feature: any) => ({
          color: 'white',
          weight: 1,
          fillColor: feature.properties.color,
          fillOpacity: 0.6,
        }),
        onEachFeature: (feature: any, layer: any) => {
          const p = feature.properties;
          const popupContent = `
            <div style="text-align:center">
              <h3 style="margin:0; color:${p.color}">Zona ${p.tasaFallo} Fallo</h3>
              <hr style="margin:5px 0">
              <b>Muestras:</b> ${p.muestras}<br>
              <b>Fallos:</b> ${p.fallos}<br>
            </div>`;
          layer.bindPopup(popupContent);
        },
      });

      // La añadimos al mapa por defecto
      geoJsonLayer.addTo(mapInstance.value);
    }
   
}

watch(showCircleCluster,(value:boolean) => {
  if(geoJsonLayer){
    if(value){
      geoJsonLayer.addTo(mapInstance.value);
    } else {
      mapInstance.value.removeLayer(geoJsonLayer);
    }
  }
});

let intervaloId: any = null;

async function iniciarVista() {
  if(inView.value){
    intervaloId = setInterval(async () => {
      await resetAllInfo();
      await getAllInfo();
      allFinalStatusItems.value = await getFinalStatusByStatitics(
        allFinalStatiticsItems.value,
      );
    }, 60000);
  }
}

async function cambiarDeVista() {
  if (intervaloId) {
    clearInterval(intervaloId);
    intervaloId = null;
  }
}

const inView = ref(false)

onMounted(async () => {
  
  getInfoHexagonInMap();
  inView.value = true
  finalURL.value =
    "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
  await getAllInfo();
  await iniciarVista();
});

onBeforeUnmount(() => {
  inView.value = false
  cambiarDeVista();
});
</script>

<style>
.LabelPMPSM {
  color: #003f7f !important;
  font-weight: bold;
  text-shadow: 1px 1px 1px black;
  /* margin-top: 20px !important; */
}

.LabelPMPAP {
  color: #d81e1e !important;
  font-weight: bold;
  text-shadow: 1px 1px 0.5px black;
  /* margin-top: 20px !important; */
}

.LabelRAJANT {
  color: green !important;
  font-weight: bold;
  /* margin-top: 20px !important; */
}

.leaflet-marker-icon {
  /* margin-left: 0 !important;
    margin-top: 0 !important;
    width: 50px !important;
    height: 100px !important; */
  background-color: transparent !important;
  border: none !important;
}
.classDown {
  filter: drop-shadow(4px 4px 5px rgb(41, 41, 41));
  display: block;
  max-width: 100%;
}
/* .leaflet-container {
    border-radius: 10px;
}
.leaflet-container:hover {
    border: 1px solid rgba(255,255,255,0.5);
} */
.mapClassBorder {
  border-radius: 10px;
  border-color: rgba(255, 255, 255, 0.9);
  /* border-width: 10px; */
}
/* .mapClassBorder:hover {
} */
.mapActiveClassBorder {
  border-radius: 15px;
  border: 4px solid rgba(255, 255, 255, 0.5);
}

.leaflet-tooltip-right {
  margin-left: 15px !important;
}

.leaflet-tooltip {
  padding: 0px !important;
  background-color: transparent !important;
  border: 1px solid #000 !important;
  border-radius: 10px !important;
}
.leaflet-tooltip-right:before {
  border-right-color: #9fa09f !important;
}
.sheetTooltip {
  border-radius: 10px;
  padding: 5px;
}
.classnameIcon {
  border-radius: 5px;
  width: 70px;
  overflow: hidden;
  border: 1px solid #000;
}
.greenSheet {
  background-color: rgba(2, 101, 2, 0.8);
  color: white;
}
.redSheet {
  background-color: rgba(219, 6, 6, 0.8);
  color: white;
}
.yellowSheet {
  background-color: rgba(238, 255, 2, 0.8);
  color: black;
}
.greySheet {
  background-color: rgba(87, 87, 87, 0.8);
  color: white;
}
.iconStatusCard {
  border-radius: 50%;
}

.rowIcon {
  align-content: center !important;
  text-align: center !important;
  padding-top: 4px;
}
.rowIcon .trueIcon {
  border-radius: 10px;
  border: 1px solid #ffffff;
}
.rowName {
  align-content: center !important;
  min-width: calc(100% - 80px);
}

.namePopUP {
  font-size: 16px;
  color: black;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.namePopUP:hover {
  font-weight: bolder;
  cursor: pointer;
}

.sheetNameIcon {
  border: 1px solid white;
  border-radius: 3px;
  background-color: green;
}

.nameClassIcon {
  font-size: 17px;
  color: white;
}

.iconMapButton {
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
}

.legendMapDash {
  font-size: 14px;
  text-transform: uppercase;
  /* letter-spacing: 1px; */
  padding-top: 1px;
}

.legendMapDash span {
  text-transform: capitalize;
}

.mapContainer {
  position: relative;
}

.mapTest {
  height: 750px;
  width: 100%;
  position: absolute;
  z-index: 1000;
  top: 0%;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}
.mapTest:hover {
  border: 3px solid rgba(255, 255, 255, 0.5);
}


.custom-marker-container {
  background: transparent !important;
  border: none !important;
}

.marker-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

/* EL PUNTO: Un solo color fijo (ej. Azul) */
.marker-dot {
  width: 14px;
  height: 14px;
  background-color: #007bff; /* Color Único Fijo */
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  margin-bottom: 2px;
}

/* La etiqueta de texto */
.marker-label {
  font-size: 10px;
  font-weight: bold;
  color: #333;
  background: rgba(255, 255, 255, 0.9);
  padding: 1px 4px;
  border-radius: 4px;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
</style>
